import { Grid2, Typography } from "@mui/material";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import AddGroupPermission from "./components/AddGroupPermission";
import AddMember from "./components/AddMember";
// import Group from "./components/Group";
import CommonAccordion from "../common-components/CommonAccordion";
import Group from "./components/Group";

function Permission() {
  const [openAddMemberDialog, setOpenAddMemberDialog] = useState(false);
  const [openAddGroupDialog, setOpenAddGroupDialog] = useState(false);
  const [openDialog, setOpenDialog] = useState(false);

  const navigate = useNavigate();
  const handleAddMemberClick = () => {
    // setOpenAddMemberDialog(true);
    navigate("/add-user");
  };
  const handleCloseAddMemberDialog = () => {
    setOpenAddMemberDialog(false);
  };
  const handleAddGroupClick = () => {
    // navigate("/add-group");
    setOpenDialog(true);
  };

  const handleCloseAddGroup = () => {
    setOpenAddGroupDialog(false);
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
  };

  return (
    <Grid2 container spacing={4} padding={"2rem"}>
      <Grid2 size={12}>
        <Typography
          sx={{
            fontWeight: 600,
            fontSize: "24px",
            color: "#101828",
          }}
        >
          Permissions
        </Typography>
      </Grid2>

      <Grid2 size={12}>
        <CommonAccordion
          title={"Groups"}
          accordionButton
          defaultOpen={true}
          buttonTitle={"Add Group"}
          children={<Group />}
          onButtonClick={handleAddGroupClick}
        />
      </Grid2>

      <AddMember
        open={openAddMemberDialog}
        onClose={handleCloseAddMemberDialog}
        onApply={handleCloseAddMemberDialog}
      />

      <AddGroupPermission
        openDialog={openDialog}
        handleCloseDialog={handleCloseDialog}
      />
    </Grid2>
  );
}

export default Permission;
